import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled as muiStyled } from "@mui/system";
import styled from "@emotion/styled";

export const RootContainer = muiStyled(Box)({
  height: "100%",
  overflow: "hidden",
});

export const HeaderContainer = muiStyled(Box)({
  fontFamily: "Poppins",
  fontSize: "18px",
  height: "40px",
  textAlign: "initial",
});

export const BodyContainer = muiStyled(Box)({
  height: "calc(100% - 40px)",
  overflowY: "auto",
});

export const CardContainer = muiStyled(Box)<{ bgColor?: String }>(
  (theme: any) => ({
    backgroundColor: theme.bgColor,
    borderRadius: "10px",
    minHeight: "110px",
    margin: "15px 0px",
    marginRight: "5px",
    cursor: "pointer"
  })
);

export const CardItemsContainer = muiStyled(Grid)({
  height: "80px",
  userSelect: "none",
});

export const CardPreviewImage = styled("img")({
  borderRadius: "5px",
  height: "60px",
  width: "100%",
});

export const AltImage = styled("div")({
  borderRadius: "5px",
  height: "60px",
  width: "100%",
});

export const CardTextContainer = muiStyled(Grid)<{ color?: String }>(
  (theme: any) => ({
    color: theme.color,
    height: "calc(100% - 80px)",
    textAlign: "initial",
    paddingLeft: 10,
    userSelect: "none",
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-line-clamp": "1",
    "-webkit-box-orient": "vertical",
    textOverflow: "ellipsis",
    "& a, & a:visited, & a:hover, & a:active": {
      color: theme.color,
      textDecoration: "underline",
    },
  })
);

export const CardPreviewContainer = muiStyled(Grid)({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingLeft: "10px",
});

export const CardPreview = muiStyled("div")<{ borderColor?: String }>(
  (theme: any) => ({
    height: 60,
    width: 100,
    backgroundColor: "white",
    borderRadius: "5px",
    border: `1px solid ${theme.borderColor}`,
  })
);

export const CardIconsContainer = muiStyled(Grid)({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
});

export const CardIconWrapper = muiStyled("div")({
  display: "flex",
});

export const CardAddNewButtonContainer = muiStyled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "15px",
});
